import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Layout } from '../components/layout';

export default function CondoWelcome() {
  const navigate = useNavigate();

  return (
    <Layout showFooter={false}>
      <div className="min-h-[calc(100vh-64px)] flex items-center justify-center px-4 py-12 bg-black">
        <div className="max-w-lg w-full text-center">

          {/* Badge-style icon */}
          <div className="w-16 h-16 rounded-full bg-[#C5A52A]/10 border border-[#C5A52A]/30 flex items-center justify-center mx-auto mb-6">
            <span className="text-[#C5A52A] text-2xl font-black font-mono">Q</span>
          </div>

          <p className="font-mono text-[10px] text-[#C5A52A] uppercase tracking-[0.3em] mb-3">
            Welcome to CYQR
          </p>

          <h1 className="text-3xl sm:text-4xl font-black text-white tracking-tight uppercase mb-4"
              style={{ fontFamily: 'Chivo, sans-serif' }}>
            You're Part of Something Bigger
          </h1>

          <p className="text-gray-400 text-sm leading-relaxed mb-8 max-w-sm mx-auto">
            Regina has{' '}
            <span className="text-white font-bold">15,500 condo owners</span>
            {' '}— nearly as many as the votes that elected our last mayor. Together, you have more
            civic influence than you might think.
          </p>

          <div className="bg-[#0d0d0d] border border-[#1a1a1a] rounded p-5 text-left mb-8 space-y-3">
            {[
              'Digital boardroom for your condo association',
              'AI-assisted meeting minutes — automatic and private',
              'Secure email voting for board resolutions',
              'Connect with condo presidents across the city',
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-[#C5A52A] flex-shrink-0 mt-1.5" />
                <p className="font-mono text-xs text-gray-300">{item}</p>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/qcca"
              className="inline-flex items-center justify-center gap-2 bg-[#C5A52A] hover:bg-yellow-400 text-black font-bold py-3 px-8 tracking-wider transition-all font-mono text-sm uppercase"
            >
              Tell Me More
            </Link>
            <button
              onClick={() => navigate('/login')}
              className="inline-flex items-center justify-center gap-2 bg-transparent border border-white/20 hover:border-white/50 text-white font-bold py-3 px-8 tracking-wider transition-all font-mono text-sm uppercase"
            >
              Take Me to the Site
            </button>
          </div>

          <p className="font-mono text-[10px] text-gray-700 mt-6">
            You can always explore the Condo Suite later from your dashboard.
          </p>
        </div>
      </div>
    </Layout>
  );
}
